import { LI, UL } from '../../../../../AbstractElements'

function DotText () {
    return (
        <UL className="dot-group pb-3 pt-0 simple-list flex-row">
            <LI />
            <LI />
            <LI />
        </UL>

    )
}
export default DotText